import permissions from '@/constants/permissions'

const SummaryOfOurStory = () => import('@/views/document/SummaryOfOurStory.vue')
export default {
  path: 'podsumowanie-naszej-historii',
  name: 'SummaryOfOurStory',
  component: SummaryOfOurStory,
  meta: {
    requireAuth: true,
    permission: [permissions.documentView, permissions.assignedDocumentView]
  }
}
